import { parseNumber, formatNumber } from 'libphonenumber-js'
import isEmpty from 'lodash/isEmpty'
import PropTypes from 'prop-types'
import queryString from 'query-string'
import React from 'react'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import { withLastLocation } from 'react-router-last-location'
import { compose } from 'recompose'
import * as yup from 'yup'
import { doTokenLogin, fetchUserExist, setNewUser } from '../actions/AuthAction'
import { getPropertyInformation } from '../actions/FlowAction'
import { Button, Form, MobileNumber, Validator } from '../components'
import * as routeService from '../services/routeService'
import * as translationService from '../services/translationService'
import { parsePhoneNumber } from '../utils/phone'
import { ERROR_INVALID_PHONE_NUMBER } from './../utils/validation/constants'
import AuthContent from './AuthContent'
import PropertyNotFoundView from './PropertyNotFoundView'

class LoginView extends React.Component {
  static propTypes = {
    getPropertyInformation: PropTypes.func,
    fetchUserExist: PropTypes.func.isRequired,
    doTokenLogin: PropTypes.func.isRequired,
    mobileNumber: PropTypes.string,
    error: PropTypes.any,
    property: PropTypes.any,
    history: PropTypes.any,
    match: PropTypes.any,
    lastLocation: PropTypes.any,
    location: PropTypes.object,
    propertyFetching: PropTypes.bool,
    propertyFail: PropTypes.bool,
    setNewUser: PropTypes.func,
    newUser: PropTypes.object,
  }

  validation = [
    {
      id: 'mobileNumber',
      validation: yup
        .string()
        .test('isValidPhoneNumber', ERROR_INVALID_PHONE_NUMBER, val => {
          if (val === undefined) return true
          if (val.length <= 3) return true
          return !isEmpty(parseNumber(val))
        })
        .required(),
    },
  ]

  state = {
    mobileNumber: this.props.mobileNumber || '+32 4',
    inputValidation: {},
    isLoading: false,
    isSubmitting: false,
  }

  componentDidMount = async () => {
    const { newUser } = this.props

    this.checkParams()

    if (newUser) {
      this.setState({ mobileNumber: parsePhoneNumber(newUser.phone) })
    }

    const propertyId = routeService.getCurrentPropertyParam() || this.props.match.params.id
    if (propertyId) {
      this.props.getPropertyInformation(propertyId)
    }
  }

  componentDidUpdate = oldProps => {
    if (this.props.location.search && this.props.location.search !== oldProps.location.search) {
      this.checkParams()
    }
  }

  checkParams = async () => {
    const params = queryString.parse(this.props.location.search)

    if (params.token) {
      try {
        await this.setState({
          isLoading: true,
        })

        await this.props.doTokenLogin(params.token)
        if (params.propertyId) {
          return routeService.goToPath(`/property/${params.propertyId}`)
        }

        routeService.goToProfilePage()
      } catch (err) {
        return err
      }
    }

    if (!isEmpty(params)) {
      // /property/{ID}?firstName=Eddy&lastName=Wally&email=bart%2Beddy%40rentio.be&phone=0476520003
      this.props.setNewUser(params)
      this.setState({
        mobileNumber: parsePhoneNumber(params.phone),
      })
      // routeService.goToPath(`/property/${this.props.match.params.propertyId}/login`)
    }
  }

  onValueChange = event => {
    const { id, value } = event.target
    this.setState({
      [id]: value,
    })
  }

  onCheckUser = event => {
    event.preventDefault()
    this.setState({ isSubmitting: true }, () => {
      Validator(this.validation, this.state)
        .then(() => {
          this.setState({
            error: null,
            inputValidation: null,
            isSubmitting: false,
          })
          this.props.fetchUserExist(formatNumber(this.state.mobileNumber, 'International'))
        })
        .catch(validationErrors => {
          this.setState({
            error: this.props.error,
            inputValidation: validationErrors,
            isSubmitting: false,
          })
        })
    })
  }

  render() {
    const {
      property,
      location: { search },
    } = this.props
    const { inputValidation, error, isSubmitting } = this.state
    const params = queryString.parse(search)

    let title = translationService.loginTitleGeneral()
    let subtitle = translationService.loginMotivationGeneral()
    if (!isEmpty(property)) {
      title = translationService.loginTitle()
      if (property.broker) {
        subtitle = translationService.loginMotivation(property.broker.name)
      } else {
        subtitle = translationService.loginMotivationNoBroker()
      }
    }

    if (this.props.propertyFail) {
      return <PropertyNotFoundView />
    }

    return (
      <AuthContent title={title} subtitle={subtitle} hasToken={!!params.token}>
        <Form onSubmit={this.onCheckUser}>
          <MobileNumber
            label={translationService.loginMobileNumberPlaceholder()}
            id="mobileNumber"
            autoFocus
            value={this.state.mobileNumber}
            onChange={this.onValueChange}
            error={
              (inputValidation && inputValidation.mobileNumber) || (error && translationService.loginPhoneFormatError())
            }
          />

          <Button primary submit onClick={this.onCheckUser} loading={isSubmitting}>
            {translationService.system('next')}
          </Button>
        </Form>
      </AuthContent>
    )
  }
}

const mapStateToProps = ({ AuthReducer, FlowReducer }) => {
  const { isFetching, user = {}, newUser, didUserExistRequest, error } = AuthReducer
  const { fetching, property = {}, propertyFail } = FlowReducer
  const { userExist, mobileNumber } = user
  return {
    isFetching,
    userExist,
    mobileNumber,
    didUserExistRequest,
    error,
    property,
    propertyFetching: fetching,
    propertyFail,
    newUser,
  }
}
const mapDispatchToProps = dispatch => ({
  setNewUser: user => dispatch(setNewUser(user)),
  fetchUserExist: mobileNumber => dispatch(fetchUserExist(mobileNumber)),
  doTokenLogin: publicId => dispatch(doTokenLogin(publicId)),
  getPropertyInformation: (propertyId, user) => dispatch(getPropertyInformation(propertyId, user)),
})

export default compose(
  translate('translations'),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(withLastLocation(LoginView))



// WEBPACK FOOTER //
// ./src/views/LoginView.js